import { useContext } from 'react';
import { GTagContext } from '../gtagContext';

/**
 * MUST be used in a descendant of the GTagProvider
 * @returns {function} the gtag function
 */
export const useGTag = () => {
	const gtag = useContext(GTagContext);
	if (!gtag) {
		// this is especially useful in TypeScript so you don't need to be checking for null all the time
		throw new Error('useGTag must be used within a GTagProvider.');
	}
	return gtag;
};
